(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('editStockItem', EditStockItemDirective);

  function EditStockItemDirective() {
    return {
      restrict: 'E',
      templateUrl: 'views/cadastros/itens_estoque/edit.html',
      controller: 'ItensEstoqueEditCtrl',
      controllerAs: 'edit',
      scope: {
        item: '<',
        products: '<',
        groups: '<',
        atividades: '<',
        units: '<'
      },
      bindToController: true
    };
  }

}());
